import { ChannelRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ChannelService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ChannelRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	authorizeAmazon(oAuthDate) {
		var url = this.routeService.authorizeAmazon(oAuthDate);
		return this.apiClient.post(url);
	}

	authorizationResultAmazon(state) {
		var url = this.routeService.authorizationResultAmazon(state);
		return this.apiClient.get(url);
	}

	updateChannelWarehouseCodes(updateChannelWarehouseCodesParams, sourceOfChange) {
		var url = this.routeService.updateChannelWarehouseCodes(updateChannelWarehouseCodesParams, sourceOfChange);
		return this.apiClient.post(url, updateChannelWarehouseCodesParams);
	}

	updateChannelCustomLabel(updateChannelCustomLabelParams, sourceOfChange) {
		var url = this.routeService.updateChannelCustomLabel(updateChannelCustomLabelParams, sourceOfChange);
		return this.apiClient.put(url, updateChannelCustomLabelParams);
	}
}

export default ChannelService;



// WEBPACK FOOTER //
// ./src/common/data/services/ChannelService.js